export const CLIENT_ACCOUNT_PAUSED_TOOLTIP_TEXT =
  "Your patient can't book appointments due to an insurance issue and has been emailed instructions to resolve it. Check your email for details.";
